import React from "react";

import {InvestmentOfferAreas} from "../components/InvestmentOfferAreas";
import {InvestmentOfferArticles} from "../components/InvestmentOfferArticles";
import {InvestmentOfferCities} from "../components/InvestmentOfferCities";
import {InvestmentOfferHeader} from "../components/InvestmentOfferHeader";
import {InvestmentOfferPartnerSection} from "../components/InvestmentOfferPartnerSection";
import {InvestmentOfferTypesSection} from "../components/InvestmentOfferTypesSection";

export const InvestmentOfferView = () => {
    return (
        <article>
            <InvestmentOfferHeader />
            <InvestmentOfferPartnerSection />
            <InvestmentOfferTypesSection />
            <InvestmentOfferAreas />
            <InvestmentOfferCities />
            <InvestmentOfferArticles />
        </article>
    );
};
import React from "react";

import {InvestmentOfferAreas} from "../components/InvestmentOfferAreas";
import {InvestmentOfferArticles} from "../components/InvestmentOfferArticles";
import {InvestmentOfferCities} from "../components/InvestmentOfferCities";
import {InvestmentOfferHeader} from "../components/InvestmentOfferHeader";
import {InvestmentOfferPartnerSection} from "../components/InvestmentOfferPartnerSection";
import {InvestmentOfferTypesSection} from "../components/InvestmentOfferTypesSection";

export const InvestmentOfferView = () => {
    return (
        <article>
            <InvestmentOfferHeader />
            <InvestmentOfferPartnerSection />
            <InvestmentOfferTypesSection />
            <InvestmentOfferAreas />
            <InvestmentOfferCities />
            <InvestmentOfferArticles />
        </article>
    );
};
